import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import type { FullShipment } from '@fv/client-types'

import { FooterBar } from '@/components/FooterBar'
import { PageHeader } from '@/components/PageHeader'
import { composeShipmentLocationSummary } from '@/utils/shipmentFuncs'

type HeaderProps = Pick<FullShipment, 'bol' | 'locations' | 'tracking'> & {
  className?: string
  noBorder?: boolean
  prefix?: string
  showBolNumber?: boolean
  trackingNumLabel?: 'PRO#' | 'Tracking#'
  selectedQuote?: { providerCode?: string; assetCarrierCode?: string }
}

export const SliderContentHeader = ({
  bol,
  className,
  locations,
  noBorder,
  prefix,
  showBolNumber = true,
  tracking,
  trackingNumLabel,
  selectedQuote,
}: HeaderProps) => {
  const locationSummary = composeShipmentLocationSummary(locations)
  const showTrackingNums = !!trackingNumLabel
  const showBol = showBolNumber && !!bol?.bolNumber
  const showTrackingNumber = showTrackingNums && !!tracking?.trackingNumber
  const showCarrierPro =
    showTrackingNums && !!tracking?.assetCarrierTrackingNumber
  const hasIdentifier = showBol || showTrackingNumber || showCarrierPro

  return (
    <PageHeader
      className={clsx(className)}
      noBorder={noBorder}
      title={
        <>
          {prefix && `${prefix?.trim()} `}
          {showBol && `BOL# ${bol?.bolNumber}`}
          {showTrackingNumber &&
            `${trackingNumLabel} ${tracking?.trackingNumber}`}
          {showCarrierPro &&
            ` / Carrier PRO# ${tracking?.assetCarrierTrackingNumber}`}
          {hasIdentifier && ' - '}
          {locationSummary}
        </>
      }
    ></PageHeader>
  )
}

export const SliderContentFooter = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <FooterBar className={clsx('flex-wrap', className)}>{children}</FooterBar>
)

export const SliderContentBody = ({ children }: PropsWithChildren) => (
  <div className="flex h-full flex-col flex-nowrap items-stretch p-6 overflow-auto">
    {children}
  </div>
)
